/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: true,
    saving: false,
    errors: null,
    openDeleteDialog: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'REQUEST_FEED_SOURCES':
            return {
                ...state,
                inProgress: false,
                feedSources: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'REQUEST_FEED_SOURCE':
            return {
                ...state,
                inProgress: false,
                feedSource: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'SUBMIT_FEED_SOURCE':
            return {
                ...state,
                saving: false,
                feedSource: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'CONFIRM_DELETE_FEED_SOURCE':
            return {
                ...state,
                openDeleteDialog: action.payload
            };
        case 'DELETE_FEED_SOURCE':
            return {
                ...state,
                saving: false,
                openDeleteDialog: action.error ? true : false,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'FEED_SOURCES_PAGE_UNLOADED':
            return {...defaultState};
        case 'ASYNC_START':
            if (action.subtype === 'REQUEST_FEED_SOURCES'
                || action.subtype === 'REQUEST_FEED_SOURCE') {
                return { ...state, inProgress: true };
            } else if (action.subtype === 'DELETE_FEED_SOURCE'
                || action.subtype === 'SUBMIT_FEED_SOURCE') {
                return { ...state, saving: true };
            }
            break;
    }

    return state;
};